@if (FORM) {
    <div id="containerBot" class="botContainer fade">
        <!--START: THIS IS THE HEADER -->
        <div class="toolbar" role="banner">
            @if (!INCHAT_CONTENT) {
                <img class="img-header" [src]="this.LOGO_HEADER" alt="" />
            }
            @if (INCHAT_CONTENT) {
                <div class="content-header">
                    <button id="mainMenuButton" class="mainMenu" [disabled]="DOTS_VALIDATOR" (click)="mainMenuButton()">{{ 'MENU' | translate }}</button>
                    @if (INCHAT_CONTENT) {
                        <img class="img-header" [src]="this.LOGO_HEADER" alt="" />
                    }
                </div>
            }
            <!-- <div *ngIf="INCHAT_CONTENT">
      <button id="contraceptiveMenuButton" class="contraceptiveMenu" [disabled]="DOTS_VALIDATOR" (click)="contraceptiveMenuBackButton()">
        <span
          [inlineSVG]="DOTS_VALIDATOR ? 'assets/icons/lista_metodos_gray.svg' : 'assets/icons/lista_metodos.svg'"
          title="Regresar al menu de métodos anticonceptivos"
          [cacheSVG]="true"
          class="float-right"
        ></span>
      </button>
    </div> -->
        </div>
        <!--END:   THIS IS THE HEADER -->
        <!--START:   THIS IS THE BODY -->
        <div class="content scroll" #botOrganon id="botOrganon">
            @if (ALERT_VIEW) {
                <div>
                    <div class="content-container-alert">
                        <h2 class="content-title-alert" [ngClass]="{ 'text-right': this.userLang === 'ar_AE' }">{{ 'ALERT_TITLE' | translate }}</h2>
                        <img class="content-image-alert" src="assets/avatars/normal.png" alt="" />
                        <p class="content-text-alert" [ngClass]="{ 'text-right': this.userLang === 'ar_AE' }">
                            {{ 'ALERT_DESCRIPTION_1' | translate }}
                        </p>
                        <p class="content-text-alert" [ngClass]="{ 'text-right': this.userLang === 'ar_AE' }" [innerHTML]="sanitizedDescription"></p>
                        <p class="content-text-alert"></p>
                    </div>
                </div>
            }
            @if (STARTER_VIEW) {
                <div>
                    <div class="starterContainer" [ngClass]="{ 'text-right': this.userLang === 'ar_AE' }">
                        <div style="margin-bottom: 25px">
                            <span class="tituloBienvenida"> {{ 'WELCOME_2' | translate }} </span>
                        </div>
                        <div class="starterTextContainer">
                            <div style="padding-bottom: 3px; padding-left: 10px">
                                <span class="leyendaBienvenida">{{ 'DISCLAIMER_2_1' | translate }}</span>
                                <br />
                                <span class="leyendaBienvenida">{{ 'DISCLAIMER_2_2' | translate }}</span>
                                <br />
                                <span class="leyendaBienvenida">{{ 'DISCLAIMER_2_3' | translate }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="icon-welcome">
                        <img src="assets/avatars/logo-welcome.png" alt="" />
                    </div>
                </div>
            }
            @if (LANGUAGE_VIEW) {
                <div>
                    <div class="header fade">
                        <span class="tituloBienvenida langTitle"> {{ 'CHOOSE_LANG' | translate }} </span>
                    </div>
                    <div class="languageCardDiv">
                        <mat-card id="en_US" class="langCard" [ngClass]="{ langCardSelected: this.userLang !== 'ar_AE' }" (click)="languageSelection('en_US')">
                            <span class="titleSelectLang">{{ 'SELECTED_OPTION.TITLE_WELCOME_EN' | translate }}</span>
                            <span class="langName">{{ 'SELECTED_OPTION.TITLE_LANG_EN' | translate }}</span>
                        </mat-card>
                        <mat-card id="ar_AE" class="langCard" [ngClass]="{ langCardSelected: this.userLang === 'ar_AE' }" (click)="languageSelection('ar_AE')">
                            <span class="titleSelectLang">{{ 'SELECTED_OPTION.TITLE_WELCOME_AR' | translate }}</span>
                            <span class="langName">{{ 'SELECTED_OPTION.TITLE_LANG_AR' | translate }}</span>
                        </mat-card>
                    </div>
                </div>
            }
            @if (SHOW_BUTTON) {
                <div>
                    <div class="header fade">
                        <div>
                            <span class="tituloBienvenida langTitle"> {{ 'WELCOME_2' | translate }} </span>
                            <br />
                            <span class="leyendaBienvenida"> {{ 'TALK_ABOUT' | translate }} </span>
                        </div>
                    </div>
                    <div class="initForm">
                        <form [formGroup]="FORM" class="fade">
                            <div class="form-group">
                                <label for="age">{{ 'AGE' | translate }}</label>
                                <div class="mat-select">
                                    <mat-select formControlName="age">
                                        @for (category of ALL_AGES; track category) {
                                            <mat-option [value]="category.value">
                                                {{ category.name }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="country">{{ 'COUNTRY_Q' | translate }}</label>
                                <div class="mat-select">
                                    <mat-select class="{{ flagCode }}" formControlName="country" (selectionChange)="countryCodeChange()" [(value)]="selectedCountry">
                                        <mat-select-trigger>
                                            @if (selectedCountry?.image) {
                                                <img [src]="selectedCountry.image" alt="{{ selectedCountry.name }}" style="width: 30px; height: 16px" />
                                            }
                                            {{ selectedCountry?.name }}
                                        </mat-select-trigger>
                                        @for (country of ALL_COUNTRIES; track country) {
                                            <mat-option [value]="country">
                                                <img [src]="country.image" alt="{{ country.name }}" style="width: 20px; height: 14px; margin-right: 8px" />
                                                {{ country.name }}
                                            </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>{{ 'AVATAR_SELECTION' | translate }}</label>
                                <br />
                                <div class="avatarContainer">
                                    @for (_av of ALL_AVATARS; track _av) {
                                        <div>
                                            <img class="item" [ngClass]="{ activeItem: _av.value === getAvatar }" (click)="selectAvatar(_av)" [src]="_av.image" [alt]="_av.value" />
                                        </div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            }
        </div>
        <!--END:   THIS IS THE BODY -->
        <!--START: THIS IS THE FOOTER -->
        <div class="containerForm">
            @if (INCHAT_CONTENT) {
                <span>{{ 'SELECT_OPTION' | translate }}</span>
            }
            @if (ALERT_VIEW) {
                <button type="button" class="buttonStarter" (click)="alertStart()">{{ 'ALERT' | translate }}</button>
            }
            @if (STARTER_VIEW) {
                <button type="button" class="buttonStarter" (click)="starterToLang()">{{ 'START' | translate }}</button>
            }
            @if (LANGUAGE_VIEW) {
                <button type="button" class="buttonStarter" (click)="langToConfig()">{{ 'CONTINUE' | translate }}</button>
            }
            @if (SHOW_BUTTON) {
                <button type="button" class="buttonInit" [disabled]="FORM?.invalid" (click)="getBasicData()">{{ 'START' | translate }}</button>
            }
        </div>
        <!--END:   THIS IS THE FOOTER -->
    </div>
}
